import { useEffect, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../auth/useAuth';
import './Login.css';

// Landing page for the backend's Google/Microsoft OAuth callback, which
// redirects here as `/sso-callback?token=...` once it has minted a Sanctum
// token for the matched user (see SsoController::callback() and
// config('app.frontend_url')). Reads the token, stores it via
// loginWithToken(), then bounces to the dashboard.
export function SsoCallback() {
  const { loginWithToken } = useAuth();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;

    const token = searchParams.get('token');
    if (!token) {
      navigate('/login?sso_error=failed', { replace: true });
      return;
    }

    loginWithToken(token)
      .then(() => navigate('/', { replace: true }))
      .catch(() => navigate('/login?sso_error=failed', { replace: true }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="login-page">
      <p className="muted">Signing you in…</p>
    </div>
  );
}
